module.exports = __webpack_public_path__ + "static/media/logo.88bc92ab.svg";